module.exports = __webpack_public_path__ + "img/step.613bb83f.svg";